import "./Gallery.module.css";
import Header from "@/reusable_sections/Header";
import SolidWoodDoor from "./sections/SolidWoodDoor";
import Footer from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <Header />
      <SolidWoodDoor />
      <Footer />
    </div>;
}